import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import src from "../../../../../images/noImage/program.png";

const useStyles = makeStyles(theme => ({
  root: {
    width: 240,
    height: 160,
    textAlign: "center"
  },
  image: {
    width: 240,
    height: 160,
    margin: "0 auto",
  }
}));

const ProgramImage = ({ fileId }) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return <div className={classes.root}>
    {fileId ?
      <img className={classes.image} src={`${baseURL}/${fileId}`} />
      : <img className={classes.image} src={src} alt="Нет изображения" />}
  </div>
};

export default ProgramImage;
